import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    assetsList: [],
    assetsRecord: [],
    assetAttachmentList: [],
    validation_error: "",
    binding_validation_error: '',
    attachment_validation_error: '',
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false,
}

const AssetsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ASSETS_REQUEST:
            return {
                ...state,
                Loading: true,
                validation_error: "",
                redirect_to_list: false,
            }
        case actionTypes.ASSETS_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
                assetsList: action.assetsList,
                showUpdateForm: false,
                showViewPage: false,
                assetsRecord: [],
            }
        case actionTypes.ASSETS_SERVER_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
                showUpdateForm: false,
                showViewPage: false,
                assetsRecord: [],
            }    
        case actionTypes.ASSETS_GET_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                assetsRecord: action.record,
                showUpdateForm: (action.actionType === 'update') ? true : false,
                showViewPage: (action.actionType === 'view') ? true : false
            }
        case actionTypes.ASSETS_VALIDATION_ERROR:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,
            }
        case actionTypes.HIDE_ASSETS_FEILD_VALIDATION_ERROR:
            if (state.validation_error && state.validation_error[action.feild_key])
                delete state.validation_error[action.feild_key]
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,

            }
        case actionTypes.REDIRECT_TO_ASSETS_LIST:
            return {
                ...state,
                redirect_to_list: true,
                showUpdateForm: false,
                showViewPage: false,
                validation_error: '',
                assetsRecord: [],
            }

        //asset binding
        case actionTypes.ASSETS_BINDING_VALIDATION_ERROR:
            return {
                ...state,
                Loading: false,
                binding_validation_error: action.binding_validation_error,
            }
        case actionTypes.HIDE_ASSETS_BINDING_VALIDATION_ERROR:
            if (state.binding_validation_error && state.binding_validation_error[action.feild_key])
                delete state.binding_validation_error[action.feild_key]
            return {
                ...state,
                Loading: false,
                binding_validation_error: action.binding_validation_error,
            } 
            
        //asset attachments
        case actionTypes.ASSETS_ATTACHMENT_VALIDATION_ERROR:
            return {
                ...state,
                Loading: false,
                attachment_validation_error: action.attachment_validation_error,
            } 
        case actionTypes.ASSETS_ATTACHMENT_SUCCESS:
            return {
                ...state,
                Loading: false,
                attachment_validation_error: "",
                assetAttachmentList: action.assetAttachmentList,
            }     
        default:
            return state;
    }
}

export default AssetsReducer;